import { render } from "./webh5account.vue?vue&type=template&id=bead0600&scoped=true"
import script from "./webh5account.vue?vue&type=script&lang=js"
export * from "./webh5account.vue?vue&type=script&lang=js"

import "./webh5account.vue?vue&type=style&index=0&id=bead0600&lang=scss&scoped=true"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bead0600"]])

export default __exports__